import { CGameBase, CGameState } from "./CGameBase"
import { SoundMgr } from "./SoundMgr";
import { CDefine, CEnumTypes } from "./CEnumTypes";
import { CLoginPlayer } from "./CLoginPlayer";
import { CGame } from "./CGame";
import { CRandomUser } from "./CRandomUser";
import { CConfig } from "./CConfig";
import { CByteArray } from "./CByteArray";

declare var liff:any;

type InviterGuildInfo = {
    Guild: number;
    Inviter: number;
	Date: string;
}

export class CMJLogin extends CGameState {
    private mainView: fgui.GComponent;
	private mLoginWnd:Window = null;
	private mLoginCheck:number = 0;
	private m_Game:CGame = null;
	private static m_instance:CMJLogin = null;
	private m_LoginURL:string;
	private m_Guild:number;
	private m_Inviter:number;
	private m_AppVer:string;
	private m_urlDefaultICON:string = "https://www.hugashaga.com.tw/Html5/icons/avatar-default.png";
	
	public constructor() {
		super();
		this.m_Game = CGame.Instance;
	}

	public static get Instance():CMJLogin {
		if( this.m_instance == null ) this.m_instance = new CMJLogin();
		return this.m_instance;
	}

	public Cleanup():void {
		//this.m_Game.SetGObjectCallbackFunc(this.mainView, this.onClickButton, false, this);
		fgui.GRoot.inst.removeChild(this.mainView);
		this.mainView.dispose();
		this.mainView = null;
		CGame.DebugLog("mjLoginScene Cleanup done.");
	}

	public Init():void {
        let ins = fgui.UIPackage.createObject("mjLoginScene", "mainLogin") as fgui.GComponent;
        ins.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
		ins.addRelation(fgui.GRoot.inst, fgui.RelationType.Size);

		// let b = ins.getChild("btn_Tester") as fgui.GButton;
		// b.visible = false;
		// b = ins.getChild("btn_Apple") as fgui.GButton;
		// b.visible = false;

		this.m_Guild = 0;
		this.m_Inviter = 0;

		this.m_LoginURL = "";

		this.mainView = ins;
		let t = this.mainView.getChild("txt_Version") as fgui.GTextField;
		t.text = "v"+CConfig.gameVersion;
		//t.text = "v0.9024";

		// let d = new Date("2024/06/21, 13:20:50");
		// alert(d.getTime());
		// let ds = new Date("2024-06-21 12:59:41");
		// let dc = new Date();
		// //let df = (dc.getTime() - ds.getTime()) / 1000;
		// let df1 = dc.getTime();
		// let df2 = ds.getTime();
		// let df = (df1 - df2) / 1000;
		// CGame.DebugLog("DF:", df);
		// alert("DF:"+df1+":"+df2+":"+df);

		fgui.GRoot.inst.addChild(ins);
		// this.m_Game.GetVersionInfo(this.onGetVersionSuccess.bind(this));

		this.CheckInviteQuery();

		this.m_Game.SetGObjectCallbackFunc(this.mainView, this.onClickButton, true, this);
		
		if( this.m_Game.m_privateCheck ) {
			let c = this.mainView.getChild("btn_Check01") as fgui.GButton;
			c.fireClick(true);

			if( CConfig.usedLine ) this.initializeLiff();
		}

		//SoundMgr.playMusic("mus/m001.mp3");
		//createjs.Tween.get(ins).to({x:0}, 500, createjs.Ease.quadOut);
	}

	public EnableButtons(enable:boolean):void {
		// let b = this.mainView.getChild("btn_Apple") as fgui.GButton;
		// b.enabled = enable;
		let b = this.mainView.getChild("btn_Login") as fgui.GButton;
		b.enabled = enable;
	}

	public AddDelayCall(dm:number, Callback:Function, v:number = 0):void {
		createjs.Tween.get(this.mainView).wait(dm).call(function() {
			Callback(v);
		});
	}

	private CheckInviteQuery():void {
		const queryString = window.location.search;
		CGame.DebugLog(queryString);
		const urlParams = new URLSearchParams(queryString);
		const p = urlParams.get('p');
		const userID = urlParams.get('userID');

		if( p != undefined && p == '100' ) {
			const base64 = urlParams.get('data');
			let tb = CGame.base64ToBytes(base64);
			let p:CByteArray = new CByteArray(tb);
			const inviter = p.readInt();
			const guild = p.readUTFBytes(5);
			const guildname = p.readUTFBytes(CDefine.GUILDNAME_LEN);
			const dateStr = p.readUTFBytes(24);
			CGame.DebugLog("decode base64:", inviter, guild, guildname, dateStr);
			let ds = new Date(dateStr);
			let dc = new Date();
			let df = (dc.getTime() - ds.getTime()) / 1000;
			CGame.DebugLog("DF:", df);
			// alert("DF:"+df);
			if( df < 5*60 ) {
				var that = this;
				this.m_Game.ShowDialog("加入公會", "無極麻將『"+guildname+"』公會（編號"+guild+"）邀請您的加入!如要加入請按確定後登入遊戲, 謝謝您!", ["確定", "取消"], function(result){
					CGame.DebugLog(result);
					if( result ) {
						that.m_Guild = parseInt(guild);
						that.m_Inviter = inviter;
					}
					that.JoinGuildLogin(dateStr);
				});
			}
		}
		else if( CConfig.reconLocalTest ) {
			const testID = urlParams.get('testid');
			if( testID != undefined ) this.m_Inviter = parseInt(testID);
		}
	}

	private JoinGuildLogin(dateStr:string):void {
		CGame.DebugLog("join guild:", this.m_Guild, this.m_Inviter);
		// var d = new Date();
		// let igi: InviterGuildInfo = {"Guild": this.m_Guild, "Inviter": this.m_Inviter, "Date":d.toLocaleString("en-ZA")};
		let igi: InviterGuildInfo = {"Guild": this.m_Guild, "Inviter": this.m_Inviter, "Date": dateStr};
		localStorage.setItem("LINEInviterGuildInfo", JSON.stringify(igi));
	}

	private CheckInviteInfoExist():void {
		CGame.DebugLog("CheckInviteInfoExist...");
		const jsonText = localStorage.getItem("LINEInviterGuildInfo");
		// alert(jsonText);
		if( jsonText != null ) {
			localStorage.removeItem("LINEInviterGuildInfo");
			CGame.DebugLog(jsonText);
			let jn = JSON.parse(jsonText);
			if( jn.Guild != undefined ) {
				// let ds = new Date(jn.Date);
				// let dc = new Date();
				// let df = (dc.getTime() - ds.getTime()) / 1000;
				// CGame.DebugLog("DF:", df);
				// // alert("DF:"+df);
				// if( df < 5*60 ) {
					this.m_Guild = jn.Guild;
					this.m_Inviter = jn.Inviter;
				// }
			}
		}
	}


	private onGetVersionSuccess(res:string):void {
		CGame.DebugLog(res);
		var json = JSON.parse(res);
		CGame.DebugLog(json.H5Version);
		//if( CConfig.gameVersion != json.H5Version ) {
		if( CConfig.gameVersion != json[CConfig.gameTarget] ) {
			if( CConfig.gameTarget != "H5" )
				this.m_Game.ShowDialog("", "版本錯誤，請更新至最新版本！", ["確定"]);
			else 
				this.m_Game.ShowDialog("", "版本不是最新，請清除瀏覽器快取！", ["確定"]);
		}
		else {
			this.initializeLiff();
			//this.m_Game.SetGObjectCallbackFunc(this.mainView, this.onClickButton, true, this);
		}
	}

	private myTestFunc(v:number):void {
		CGame.DebugLog("myTestFunc:", v, this.mLoginCheck);
	}

	private DoLogin2Server(userID:string, displayName:string, email:string, pictureURL:string, loginType:number = CDefine.LOGIN_LINE):void {
		this.EnableButtons(false);
		if( this.m_Guild > 0 ) this.m_Game.m_fgInviteGuild = 1;
		this.m_Game.resetPacket();
		this.m_Game.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GLOBAL_LOGIN);
		this.m_Game.m_CPkt.WriteInt(CConfig.gameVersion);
		this.m_Game.m_CPkt.WriteUTFBytes(userID, CLoginPlayer.OPENID_LEN);
		this.m_Game.m_CPkt.WriteUTFBytes(displayName, CLoginPlayer.NICKNAME_LEN);
		this.m_Game.m_CPkt.WriteUTFBytes(email, CLoginPlayer.EMAIL_LEN);
		this.m_Game.m_CPkt.WriteUTFBytes(pictureURL, CLoginPlayer.PICTUREURL_LEN);
		this.m_Game.m_CPkt.WriteInt(this.m_Guild);
		this.m_Game.m_CPkt.WriteInt(this.m_Inviter);
		this.m_Game.Login2Server(loginType);
	}

	private RandomUserLogin():void {
		let openid:string = CRandomUser.openid;
		if( CConfig.reconLocalTest ) {
			if( this.m_Inviter > 0 ) openid = "qweytudsfhjzsbjcbjahhsdj987"+this.m_Inviter;
		}
		this.DoLogin2Server(openid, CRandomUser.socialName, "none\u0040gmail.com", CRandomUser.avatar);
	}

	private initializeLiff() {
		// https://liff.line.me/2001560893-ZOq2LjdG
		// https://wuji.hugashaga.com.tw/mj16s/dist/
		liff.init({
			liffId: "2001560893-ZOq2LjdG"
		}).then(() => {
			if (!liff.isLoggedIn()) {
				alert("用戶未登入");
				liff.login();
			} else {
				// alert("用戶已登入");
				const user = liff.getDecodedIDToken();
        		if (user) {
            		console.log(JSON.stringify(user));
					this.CheckInviteInfoExist();
					this.DoLogin2Server(user.sub, user.name, user.email, user.picture);
				}
				// liff.getProfile()
				// 	.then(profile => {
				// 		console.log(profile.displayName, profile.userId, profile.pictureUrl);
				// 	})
				// 	.catch((err) => {
				// 		console.log('error', err);
				// 	});
			}
		}).catch((err) => {
			console.log('初始化失敗', err);
		});
	}

	private onClickButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");

		if ( btn.name == "btn_Check01") {
			//this.m_Game.m_IAP.Init();
			// CGame.DebugLog("open window ...");
			// var menuAddress = "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653928207&redirect_uri=http://192.168.1.200/LineLogin/Callback.aspx&scope=openid%20profile%20email&state=js90ad3e65-7565-47e5-9a6b-8590b44c0498";
			// window.open(menuAddress, "_blank");
			if( CConfig.gameTarget == "H5" && this.m_Game.isMobile() ) this.m_Game.toggleFullScreen();
		}
		let c = this.mainView.getChild("btn_Check01") as fgui.GButton;
		CGame.DebugLog(c.selected);
		if ( btn.name == "btn_Login") {
			if( c.selected) {
				this.m_Game.m_privateCheck = true;
				this.m_Game.SaveConfig();
				if( CConfig.usedLine == false ) {
					this.RandomUserLogin();
				}
				else {
					this.initializeLiff();
				}
			}
			else {
				this.m_Game.ShowDialog("", "必須勾選同意使用協議", ["確定"]);
			}
		}
		else if( btn.name == "btn_UserRule" ) {
			window.open("https://www.fullfun.info/TermsofService.html", "_blank");
		}
		else if( btn.name == "btn_PrivatePolicy" ) {
			window.open("https://www.fullfun.info/privacy.html", "_blank");
		}
    }
}
